import './index.scss'
// import { ReactComponent as Logo } from '../../assets/header-logo.svg'
// import { ReactComponent as Logo } from '../../assets/Nova Poshta Global.svg'
import { ReactComponent as Logo } from '../../assets/Group (1).svg'

import Navigation from '../Navigation'
import { useNavigate } from 'react-router'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import GlobalState from '../../stores/GlobalState'

const Header = observer(() => {
  const navigate = useNavigate()

  return (
    <header className={classNames('header ')}>
      <div className={classNames('header__container')}>
        <div className="header__left">
          <Logo
            className={classNames('header__logo')}
            onClick={() => {
              navigate(
                `${
                  GlobalState.currentLocale.lang.includes('En') ? '/en/' : '/'
                }`,
              )
              window.location.reload()
              localStorage.clear()
            }}
          />
          <span className="header__separator"></span>
          <span className="header__country">Ukraine</span>
        </div>
        <Navigation />
      </div>
    </header>
  )
})

export default Header
